import { useState } from 'react'
import { useLoaderData, useNavigate } from 'react-router'
import { BranchPageHeading } from '@/components/subscription/branch-page-heading'
import { TextLink } from '@/components/subscription/text-link'
import { formatTime } from '@/lib/shipment'
import { createClient } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { Account } from '@/api-client/Account'

export const loader = async () => {
  return await fetchSubscriptions()
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions({ category: 'green' })
}

export const SubscriptionBranchMypageDelete: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData<typeof loader>()
  const [errorMessage, setErrorMessage] = useState('')

  const navigate = useNavigate()
  const subscription = subscriptions[0]
  const [checked, setChecked] = useState(false)

  const handleClickCancel: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      await createClient(Account).deleteAccount()
      navigate('/subscription/branch', { state: { message: 'アカウントを削除しました。FLOWERをご利用いただきありがとうございました。' } })
    } catch (error) {
      setErrorMessage(error.response.data.error.message_displayable)
    }
  }

  return (
    <div className="w-full space-y-8 pt-4 pb-18">
      <BranchPageHeading
        main="アカウントの削除"
        sub={subscription && `${formatTime(1000 * subscription.attributes.skip_deadline)}までのお手続きで、次回発送分から定期便を停止できます`}
      />
      <div className="flex flex-col items-center gap-4">
        <h3 className="text-[15px] font-bold text-black leading-relaxed">必ずお読みください</h3>
        <ul className="list-disc pl-4 text-[15px] text-black leading-relaxed">
          {subscription && <li>上記の期限を過ぎてしまった場合は、次回のお届けをキャンセルできません。</li>}
          <li>注文履歴や個人情報など、すべての情報が削除されます。</li>
          <li>一度アカウントを削除すると、今後同じユーザー情報でログインできなくなります。</li>
          {subscription && (
            <li>
              アカウントは削除せず、定期便のみ停止したい場合は<TextLink to="/subscription/branch/mypage/cancel">こちら</TextLink>からお手続きいただけます。
            </li>
          )}
        </ul>
      </div>
      <div className="w-full flex flex-col items-center gap-8">
        <label className="flex items-center gap-2 cursor-pointer">
          <div className="flex flex-row items-center gap-2">
            <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
            <span>注意事項を確認しました</span>
          </div>
        </label>
        <div className="flex flex-col items-center gap-2 w-full">
          {!!errorMessage && <p>{errorMessage}</p>}
          <button
            type="button"
            disabled={!checked}
            className="w-full py-5 bg-black text-white text-[15px] font-medium rounded-full cursor-pointer hover:bg-main disabled:bg-main transition-colors"
            onClick={handleClickCancel}
          >
            FLOWERのアカウントを削除
          </button>
        </div>
        <TextLink to="/subscription/branch/mypage">マイページに戻る</TextLink>
      </div>
    </div>
  )
}
